const _import = require("../_import_" + process.env.NODE_ENV);

const routes = [
  {
    path: "/",
    name: "Login",
    component: _import("Login"),
    meta: {
      parent: 0,
    },
    children: [
        {
            path: "/channel",
            name: "channel",
            component: _import("home/channel"),
            meta: {
              menuName: "我要捐款",
              index:1 //面包屑顺序
            },
          },
	  {
		path: "/juankuanAPP",
		name: "juankuanAPP",
		component: _import("home/juankuanAPP"),
		meta: {
		  menuName: "我要捐款",
		  index:1 //面包屑顺序
		},
	  },
      {
        path: "/wuping",
        name: "wuping",
        component: _import("home/wuping"),
        meta: {
          menuName: "我要捐物",
          index:1 //面包屑顺序
        },
      },
    ],
  },
];
export default routes;
